import React from "react";
import { WarningOutlined } from "@ant-design/icons";
import { MyModal } from "../../../../components/styled-components"; // Assuming you have your custom modal styled component

interface WarningNoFileModalProps {
  visible: boolean;
  onClose: () => void;
  message: string; // Message to display in the modal
}

const WarningNoFileModal: React.FC<WarningNoFileModalProps> = ({ visible, onClose, message }) => {
  return (
    <MyModal
      title={
        <>
          <WarningOutlined /> Warning
        </>
      }
      visible={visible}
      onOk={onClose}
      onCancel={onClose}
      okText="OK"
    >
      <p>{message}</p>
    </MyModal>
  );
};

export default WarningNoFileModal;
